"use strict";

(function (root, $, undefined) {
  "use strict";
})(undefined, jQuery);